import React, { FC } from 'react';
import { IPortfolioData } from 'models/portfolio';
import { Modal } from 'react-bootstrap';

interface IAllProjectProps {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  data: IPortfolioData[];

  previewProjectBtnClick(siteName: string, siteUrl: string): void;

  previewSourceCodeBtnClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export const ClAllProject: FC<IAllProjectProps> = ({
  show,
  setShow,
  data,
  previewProjectBtnClick,
  previewSourceCodeBtnClick,
}) => {
  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      backdrop="static"
      keyboard={false}
      centered
      fullscreen={true}
    >
      <Modal.Header closeButton>
        <Modal.Title>All Projects</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-all-project-custom">
        <div className="portfolio-items-container">
          {data.map((val, index) => (
            <div key={index} className="item">
              <div className="image-container">
                <img
                  src={val.preview}
                  alt={val.siteName.replaceAll(' ', '-')}
                />
              </div>
              <div className="portfolio-desc">
                <h6 className="name">{val.siteName}</h6>
                <p className="desc">{val.description}</p>
              </div>
              <div className="badge-container align-items-start">
                {val.badge.map((item, itemKey) => (
                  <p className="badge-item" key={itemKey}>
                    {item}
                  </p>
                ))}
              </div>
              <div className="button-container">
                <button
                  onClick={previewSourceCodeBtnClick}
                  className="download-resume github"
                >
                  Github
                </button>
                <button
                  onClick={() =>
                    previewProjectBtnClick(val.siteName, val.siteUrl)
                  }
                  className="download-resume preview"
                >
                  Preview
                </button>
              </div>
            </div>
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
};
